export const ApiEndpoints = {
  profileData: '/apis/v1/profile/',
  pinCode: '/apis/v1/pincode/',
  imageUploadUrlRequest: '/apis/v1/files/upload/',
  newShopRequest: '/apis/v1/shops/add/'
};
